// src/features/vertraege/types.ts
//
// Typen fuer das Vertragswesen. Bewusst als eigenes Modul und nicht in
// src/shared/types/index.ts, damit das Feature fuer sich steht und die
// zentrale Typdatei nicht weiter waechst.

export type VertragStatus =
  | 'entwurf'
  | 'versendet'
  | 'angesehen'
  | 'signiert'
  | 'zurueckgezogen'
  | 'abgelaufen';

export interface Vertragsvorlage {
  id: string;
  typ: string;
  version: number;
  name: string;
  inhalt: Record<string, unknown>;
  standardwerte: Record<string, string>;
  aktiv: boolean;
  gueltig_ab: string;
  bemerkung: string | null;
  created_at: string;
  updated_at: string;
}

export interface Vertrag {
  id: string;
  vertragsnummer: string;

  customer_id: string;
  vorlage_id: string;
  vorlage_typ: string;
  vorlage_version: number;

  status: VertragStatus;

  variablen: Record<string, string>;
  dokument_snapshot: Record<string, unknown> | null;

  token: string | null;
  ablauf_am: string | null;
  empfaenger_contact_id: string | null;
  empfaenger_name: string | null;
  empfaenger_email: string | null;

  pdf_entwurf_path: string | null;
  pdf_signiert_path: string | null;
  pdf_dateiname: string | null;
  pdf_hash_sha256: string | null;

  versendet_am: string | null;
  erstmals_geoeffnet_am: string | null;
  signiert_am: string | null;
  zurueckgezogen_am: string | null;

  unterzeichner_name: string | null;
  unterzeichner_ip: string | null;
  unterzeichner_user_agent: string | null;

  sepa_mandat_erteilt_am: string | null;
  sepa_mandat_iban: string | null;
  sepa_mandat_uebersprungen_am: string | null;

  erstellt_von_staff_id: string | null;
  erstellt_von_email: string | null;

  created_at: string;
  updated_at: string;
}

/** Ein aktiver Ansprechpartner, der den Kunden rechtsgeschaeftlich vertritt. */
export interface Vertretungsberechtigter {
  id: string;
  vorname: string | null;
  nachname: string | null;
  email: string;
  geschlecht: string | null;
  funktion: string | null;
}

/** Die im Formular veraenderbaren Vertragsvariablen. */
export interface VertragVariablen {
  kunde_vertreter_bezeichnung?: string;
  start_abrechnungsmonat?: string;
  preis_pro_arbeitnehmer?: string;
  onboarding_pauschale?: string;
  onboarding_monat?: string;
  haftung_hoechstbetrag?: string;
  [schluessel: string]: string | undefined;
}

export interface VertragErzeugenParams {
  customerId: string;
  vertragId?: string;
  empfaengerContactId?: string;
  variablen?: VertragVariablen;
  vorlageTyp?: string;
  previewOnly?: boolean;
}

export interface VertragErzeugenErgebnis {
  success: true;
  preview: boolean;
  vertrag?: Vertrag;
  pdfBase64: string;
  filename: string;
  variablen: Record<string, string>;
  hash: string;
}

export interface VertragErzeugenFehler {
  success: false;
  error: string;
  /** Benannte Liste fehlender Stammdaten, falls die Pruefung angeschlagen hat. */
  fehlendeDaten?: string[];
  /** Mehrere Vertretungsberechtigte, aus denen gewaehlt werden muss. */
  auswahl?: Array<{ id: string; name: string; funktion: string | null }>;
}

export type VertragErzeugenAntwort = VertragErzeugenErgebnis | VertragErzeugenFehler;

export const VERTRAG_STATUS_LABEL: Record<VertragStatus, string> = {
  entwurf: 'Entwurf',
  versendet: 'Zur Unterschrift versendet',
  angesehen: 'Vom Kunden geöffnet',
  signiert: 'Signiert',
  zurueckgezogen: 'Zurückgezogen',
  abgelaufen: 'Abgelaufen'
};

export const VERTRAG_STATUS_FARBE: Record<VertragStatus, { text: string; hintergrund: string; rand: string }> = {
  entwurf: { text: '#92400E', hintergrund: '#FFFBEB', rand: '#FDE68A' },
  versendet: { text: '#1E40AF', hintergrund: '#EFF6FF', rand: '#BFDBFE' },
  angesehen: { text: '#3730A3', hintergrund: '#EEF2FF', rand: '#C7D2FE' },
  signiert: { text: '#065F46', hintergrund: '#ECFDF5', rand: '#A7F3D0' },
  zurueckgezogen: { text: '#374151', hintergrund: '#F3F4F6', rand: '#D1D5DB' },
  abgelaufen: { text: '#991B1B', hintergrund: '#FEF2F2', rand: '#FECACA' }
};
